<script>
    /* Executable code section of the program */
    //Tools importation
    import {userLocalData} from "../apis/storage"
    //Component importation
  import MeetingsCentral from "./NetworkingsBreaksCentral.svelte";

  //Auxiliary variables
export let event
  export let colorBtn


    /* End of the section */
</script>
<!-- Section to place the HTML code -->
<div class="accordion" id="accordionExample">
    {#each event.networkingBreaks as day, index}
      <div class="accordion-item">
        <h1 class="accordion-header">
          <button
            class="accordion-button tittleHeader"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#{index + 1}"
            aria-expanded="false"
            aria-controls="collapseOne {index + 1}"
            style="--event-Color: {colorBtn}; background-color: {colorBtn}; color:white;"
          >
            Meetings - {day.eventDay}
          </button>
        </h1>
        {#if index === 0}
          <div
            id={index + 1}
            class="accordion-collapse collapse show"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body breaksContainer">
              <MeetingsCentral
                user={$userLocalData}
                networkingData={day}
                indexPositionArray={index}
              />
            </div>
          </div>
        {:else}
          <div
            id={index + 1}
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body breaksContainer">
              <MeetingsCentral
                user={$userLocalData}
                networkingData={day}
                indexPositionArray={index}
              />
            </div>
          </div>
        {/if}
      </div>
    {/each}
  </div>


<!-- End of the section -->
<style>
    /* Section to place the code styles */
    
  .tittleHeader {
    font-size: 25px;
  }
  
  .breaksContainer {
    padding: 30px;
    display: flex;
    justify-content: center;
  }


/* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
    
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {

  }
    /* End of the section */
</style>
